const RAD_TO_DEG = 180 / Math.PI;
const DEG_TO_RAD = Math.PI / 180;

export {
  RAD_TO_DEG,
  DEG_TO_RAD
};
